<template>
  <div class="pref-progress">
    <v-progress-circular
      :size="80"
      :width="15"
      :value="getPrefPercent"
      :color="prefData.match > 0 ? prefData.color : colors.hwayzShadow"
    />
    <div
      :style="{'color': prefData.match > 0 ? prefData.color : colors.hwayzShadow}"
      class="pref-percent"
    >
      <h3>
        {{ getPrefPercent }}%
      </h3>
      <span>
        match
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    prefData: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('common', ['isMobile']),

    getPrefPercent() {
      if (!this.prefData.match && !this.prefData.total) {
        return 0
      }
      return Math.round(
        (this.prefData.match / this.prefData.total) * 100
      ).toString()
    }
  }
}
</script>

<style lang="sass" scoped>
.pref-progress
  display: flex
  flex-flow: column
  justify-content: flex-start
  align-items: center
  @media only screen and (min-width: 600px)
    flex-flow: row
    justify-content: center
.pref-percent
  margin-left: 15px
  text-align: left
  h3
    font-size: 50px
    line-height: 61px
    color: #000000
  span
    font-size: 18px
    line-height: 22px
    color: #000000
</style>
